import { render, staticRenderFns } from "./process-bar.vue?vue&type=template&id=23b76438&scoped=true&"
import script from "./process-bar.vue?vue&type=script&lang=ts&"
export * from "./process-bar.vue?vue&type=script&lang=ts&"
import style0 from "./process-bar.vue?vue&type=style&index=0&id=23b76438&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b76438",
  null
  
)

export default component.exports